"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _tslib = require("tslib");

var _react = _interopRequireDefault(require("react"));

var _i18n = require("@lce/i18n");

var _slice = require("@lce/slice");

var _SuperLinkProvider = require("./SuperLinkProvider");

var _urlHelpers = require("./url-helpers");

var Styled = _interopRequireWildcard(require("./SuperLink.style"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable @typescript-eslint/no-explicit-any */

/* eslint-disable react/forbid-component-props */

/* eslint-disable max-lines-per-function */
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
var SuperLink = function SuperLink(_a) {
  var _b = _a.localize,
      localize = _b === void 0 ? true : _b,
      href = _a.href,
      body = _a.body,
      bodyContinue = _a.bodyContinue,
      children = _a.children,
      _c = _a.ref,
      ref = _c === void 0 ? null : _c,
      classSelector = _a.classSelector,
      props = (0, _tslib.__rest)(_a, ["localize", "href", "body", "bodyContinue", "children", "ref", "classSelector"]);
  var _d = (0, _SuperLinkProvider.useSuperLinkState)().state,
      safeDomains = _d.safeDomains,
      LinkComponent = _d.LinkComponent;

  var _e = (0, _i18n.useTranslation)(),
      t = _e[0],
      language = _e[1].language; // tslint:disable-next-line: strict-type-predicates


  var oneTrust = typeof window !== 'undefined' && window.OneTrust;

  if (classSelector) {
    return _react["default"].createElement(_slice.Anchor, (0, _tslib.__assign)({
      className: classSelector,
      "data-testid": "Anchor__" + classSelector,
      onClick: function onClick(event) {
        event.preventDefault();
        oneTrust === null || oneTrust === void 0 ? void 0 : oneTrust.ToggleInfoDisplay();
      },
      tabIndex: 0
    }, props), children);
  }

  if ((0, _urlHelpers.isLocalLink)(href) || (0, _urlHelpers.isMailtoLink)(href) || (0, _urlHelpers.isTelLink)(href)) {
    return _react["default"].createElement(_slice.Anchor, (0, _tslib.__assign)({
      "data-testid": "Anchor",
      href: href
    }, props), children);
  }

  var localizedHref = href.split('')[0] === '/' ? "/" + language + href : href;

  if (!(0, _urlHelpers.isExternalLink)(href)) {
    return _react["default"].createElement(Styled.SliceLink, (0, _tslib.__assign)({
      as: LinkComponent,
      "data-testid": "RouterLink",
      to: localize ? localizedHref : href
    }, props), children);
  } else if ((0, _urlHelpers.isSafeLink)(href, safeDomains)) {
    return _react["default"].createElement(_slice.Anchor, (0, _tslib.__assign)({
      "data-testid": "Anchor",
      href: href
    }, props), children);
  }

  return _react["default"].createElement(_slice.ExternalLink, (0, _tslib.__assign)({
    "data-testid": "ExternalLink",
    href: href,
    modalOptions: {
      title: t('Homepage.DefaultModalOptions.Title'),
      body: body ? body : t('Homepage.DefaultModalOptions.Body'),
      bodyContinue: bodyContinue ? bodyContinue : t('Homepage.DefaultModalOptions.Body Continue'),
      cancelText: t('Homepage.DefaultModalOptions.Cancel'),
      continueText: t('Homepage.DefaultModalOptions.Continue'),
      closeTitle: t('Homepage.DefaultModalOptions.Close')
    }
  }, props), children);
};

var _default = SuperLink;
exports["default"] = _default;